import { NAVBAR_HEIGHT } from './layoutMetrics';

/**
 * Page shell for every authenticated route.
 *
 * Pages leave their own top offset (CONTENT_TOP_OFFSET) because the navbar is
 * `position: fixed` and therefore takes no space in flow. `overflowX: hidden`
 * keeps a single wide child (a table, a chart, a long SQL block) from giving
 * the whole document a horizontal scrollbar on small screens.
 */
const Container = ({ children }) => {
  return (
    <div style={{
      width: '100%',
      maxWidth: '100vw',
      minHeight: `calc(100vh - ${NAVBAR_HEIGHT})`,
      overflowX: 'hidden',
      position: 'relative'
    }}>
      {children}
    </div>
  );
};

export default Container;
